import * as Yup from "yup";

export const strategyschema = Yup.object({
  name: Yup.string().min(2).max(25).required("Please Enter strategy Name"),
  details: Yup.string()
    .min(2)
    .max(100)
    .required("strategy description required"),
  custodian: Yup.string().required("Please Select Custodian"),
  minvalue: Yup.number()
  .moreThan(0, 'Minimum value must be equal or greater than 1')
  .required('Minimum value is required'),
  selectperf: Yup.string().required("Please Select Frequency"),
  selectmang: Yup.string().required("Please Select Frequency"),
  perfper: Yup.string().min(0).max(25).required("Required %"),
  manageper: Yup.string(),
  hurdleRateApplicable: Yup.string(),
  hurdleRateType: Yup.string().when('hurdleRateApplicable', {
    is: 'Yes',
    then: Yup.string().required("Hurdle Rate Type is required"),
  }),
  hurdleRateValue: Yup.number()
    .when('hurdleRateType', {
      is: 'Fixed',
      then: Yup.number()
        .required("Hurdle Rate is required")
        .max(100, "Hurdle Rate cannot exceed 100%"),
    }),
  benchmark: Yup.string().when('hurdleRateType', {
    is: 'Benchmark',
    then: Yup.string().required("Benchmark is required"),
  }),
});
